import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-arrow-right\">\n<g>\n\t<g>\n\t\t<path d=\"M15.7,10.2C15.7,10.2,15.7,10.2,15.7,10.2c0,0.3-0.1,0.6-0.3,0.8l-9,8.2c-0.4,0.4-1.1,0.4-1.5-0.1S4.5,18,5,17.6l8.1-7.5\n\t\t\tL4.6,2.4C4.2,2,4.1,1.3,4.5,0.8C5,0.4,5.6,0.4,6.1,0.8l9.3,8.6C15.6,9.6,15.7,9.9,15.7,10.2z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol